import type {
  Concept,
  EntityMainType,
  EntitySubType,
  LinkEntityType} from 'types';
import {
  EntitySubTypes
} from 'types';

export const inTargetEntityType = (
  subtype: Concept,
  type: LinkEntityType,
): boolean => {
  return (
    subtype === type ||
    (EntitySubTypes[type as EntityMainType] ?? []).includes(
      subtype as EntitySubType,
    )
  );
};
